import VuexORM from '@vuex-orm/core';
import VuexORMAxios from '@vuex-orm/plugin-axios';
import VuexORMisDirtyPlugin from '@vuex-orm/plugin-change-flags';
import VuexORMSearch from '@vuex-orm/plugin-search';

// Import model files
import AcknowledgeInformationActivity from '@/models/AcknowledgeInformationActivity.js';
import AcknowledgeInformationActivityTemplate from '@/models/AcknowledgeInformationActivityTemplate.js';
import Activity from '@/models/Activity.js';
import ActivitySettings from '@/models/ActivitySettings.js';
import ActivitySettingsTemplate from '@/models/ActivitySettingsTemplate.js';
import ActivityStatus from '@/models/ActivityStatus.js';
import ActivitySubmission from '@/models/ActivitySubmission.js';
import ActivityTemplate from '@/models/ActivityTemplate.js';
import ActivityType from '@/models/ActivityType.js';
import ActivityUpdate from '@/models/ActivityUpdate.js';
import AnomalyDetection from '@/models/AnomalyDetection.js';
import AnomalyDetectionResult from '@/models/AnomalyDetectionResult.js';
import AttemptAuthorization from '@/models/AttemptAuthorization.js';
import Attendance from '@/models/Attendance.js';
import AttendanceComment from '@/models/AttendanceComment.js';
import AttendanceScenario from '@/models/AttendanceScenario.js';
import AutomatedSurvey from '@/models/AutomatedSurvey.js';
import AutomatedSurveyAssignment from '@/models/AutomatedSurveyAssignment.js';
import AutomatedSurveyTarget from '@/models/AutomatedSurveyTarget.js';
import AutomatedSurveyTemplate from '@/models/AutomatedSurveyTemplate.js';
import BellNotification from '@/models/BellNotification.js';
import ChatExcerpt from '@/models/ChatExcerpt.js';
import ConfirmNavigationWindow from '@/models/ConfirmNavigationWindow.js';
import Contact from '@/models/Contact.js';
import Course from '@/models/Course.js';
import CourseAnnouncement from '@/models/CourseAnnouncement.js';
import CourseCodeable from '@/models/CourseCodeable.js';
import CourseCodeEvaluationTemplate from '@/models/CourseCodeEvaluationTemplate.js';
import CourseCodes from '@/models/CourseCodes.js';
import CourseEnrollment from '@/models/CourseEnrollment.js';
import CourseEnrollmentEnrollmentGroup from '@/models/CourseEnrollmentEnrollmentGroup.js';
import CourseGrade from '@/models/CourseGrade.js';
import CourseGroup from '@/models/CourseGroup.js';
import CourseLogEntry from '@/models/CourseLogEntry.js';
import CourseSettings from '@/models/CourseSettings.js';
import CourseSettingsTemplate from '@/models/CourseSettingsTemplate.js';
import CourseTemplate from '@/models/CourseTemplate.js';
import CourseTemplateGroup from '@/models/CourseTemplateGroup.js';
import CourseTemplateMenuItem from '@/models/CourseTemplateMenuItem.js';
import Dashboard from '@/models/Dashboard.js';
import DiscussionReply from '@/models/DiscussionReply.js';
import DiscussionThread from '@/models/DiscussionThread.js';
import DiscussionThreadActivity from '@/models/DiscussionThreadActivity.js';
import ElearningPackageActivity from '@/models/ElearningPackageActivity.js';
import EnrollmentGroup from '@/models/EnrollmentGroup.js';
import EnrollmentGroupColor from '@/models/EnrollmentGroupColor.js';
import EnrollmentGroupTimePeriod from '@/models/EnrollmentGroupTimePeriod.js';
import EvaluationTemplate from '@/models/EvaluationTemplate.js';
import FeatureFlag from '@/models/FeatureFlag.js';
import FileSubmissionActivity from '@/models/FileSubmissionActivity.js';
import FileSubmissionActivityTemplate from '@/models/FileSubmissionActivityTemplate.js';
import FlashcardActivity from '@/models/FlashcardActivity.js';
import FlashcardActivityTemplate from '@/models/FlashcardActivityTemplate.js';
import FlashcardBuilderState from '@/models/FlashcardBuilderState.js';
import FlashcardSessionState from '@/models/FlashcardSessionState.js';
import Gradebook from '@/models/Gradebook.js';
import GradebookGrade from '@/models/GradebookGrade.js';
import GradingScheme from '@/models/GradingScheme.js';
import GradingSchemeCriteria from '@/models/GradingSchemeCriteria.js';
import Group from '@/models/Group.js';
import GroupCategory from '@/models/GroupCategory.js';
import GradebookPreview from '@/models/gradebooks/GradebookPreview.js';
import Icon from '@/models/Icon.js';
import InstitutionSetting from '@/models/InstitutionSetting.js';
import Integration from '@/models/Integration';
import Intervention from '@/models/Intervention.js';
import InterventionLog from '@/models/InterventionLog.js';
import InterventionMethod from '@/models/InterventionMethod.js';
import IdentityVerification from '@/models/identity-verification/IdentityVerification.js';
import IdentityVerificationAttemptQuestions from '@/models/identity-verification/IdentityVerificationAttemptQuestions.js';
import Location from '@/models/Location.js';
import LocationContact from '@/models/LocationContact.js';
import LocationGroup from '@/models/LocationGroup.js';
import LocationType from '@/models/LocationType.js';
import LogicalAttendanceWeek from '@/models/LogicalAttendanceWeek.js';
import LtiContext from '@/models/LtiContext.js';
import LtiResourceContent from '@/models/LtiResourceContent.js';
import LtiResourceLink from '@/models/LtiResourceLink.js';
import LtiResourceLinkActivity from '@/models/LtiResourceLinkActivity.js';
import LtiResourceLinkActivityTemplate from '@/models/LtiResourceLinkActivityTemplate.js';
import LtiTool from '@/models/LtiTool.js';
import LtiToolActivity from '@/models/LtiToolActivity.js';
import LtiToolActivityTemplate from '@/models/LtiToolActivityTemplate.js';
import LtiToolDeployment from '@/models/LtiToolDeployment.js';
import Media from '@/models/Media.js';
import Meeting from '@/models/Meeting.js';
import MeetingLink from '@/models/MeetingLink.js';
import MeetingParticipant from '@/models/MeetingParticipant.js';
import MeetingParticipantComment from '@/models/MeetingParticipantComment.js';
import MeetingParticipantLog from '@/models/MeetingParticipantLog.js';
import MeetingRecording from '@/models/MeetingRecording.js';
import MeetingUser from '@/models/MeetingUser.js';
import Message from '@/models/Message.js';
import MessageAlert from '@/models/MessageAlert.js';
import MessageMenu from '@/models/MessageMenu.js';
import ModelPermission from '@/models/ModelPermission.js';
import ModelRole from '@/models/ModelRole.js';
import Note from '@/models/Note.js';
import Notification from '@/models/Notification.js';
import Objective from '@/models/Objective.js';
import ObjectiveCriteria from '@/models/ObjectiveCriteria.js';
import Permission from '@/models/Permission.js';
import PodcastActivity from '@/models/PodcastActivity.js';
import PodcastActivityTemplate from '@/models/PodcastActivityTemplate.js';
import Prerequisite from '@/models/Prerequisite.js';
import ProctorDashboardControlPanel from '@/models/ProctorDashboardControlPanel.js';
import Page from '@/models/pages/Page.js';
import PageFolder from '@/models/pages/PageFolder.js';
import PageGroup from '@/models/pages/PageGroup.js';
import PageViewGroup from '@/models/pages/PageViewGroup.js';
import Quiz from '@/models/Quiz.js';
import QuizActivity from '@/models/QuizActivity.js';
import QuizAttempt from '@/models/QuizAttempt.js';
import QuizAttemptManager from '@/models/QuizAttemptManager.js';
import ReadReceipt from '@/models/ReadReceipt.js';
import Remediation from '@/models/Remediation.js';
import RemediationProcess from '@/models/RemediationProcess.js';
import Reply from '@/models/Reply.js';
import Role from '@/models/Role.js';
import RolePermission from '@/models/RolePermission.js';
import Rubric from '@/models/Rubric.js';
import RubricBank from '@/models/RubricBank.js';
import RubricBankGroup from '@/models/RubricBankGroup.js';
import RubricCriteria from '@/models/RubricCriteria.js';
import RubricCriteriaRating from '@/models/RubricCriteriaRating.js';
import Satisfier from '@/models/Satisfier.js';
import SatisfierTemplate from '@/models/SatisfierTemplate.js';
import Section from '@/models/Section.js';
import SectionSettings from '@/models/SectionSettings.js';
import SectionSettingsTemplate from '@/models/SectionSettingsTemplate.js';
import SectionTemplate from '@/models/SectionTemplate.js';
import SlideDeck from '@/models/SlideDeck.js';
import SlideDeckActivity from '@/models/SlideDeckActivity.js';
import SlideDeckActivityTemplate from '@/models/SlideDeckActivityTemplate.js';
import SlideDeckGroup from '@/models/SlideDeckGroup.js';
import Status from '@/models/Status.js';
import Survey from '@/models/Survey.js';
import SurveyActivity from '@/models/SurveyActivity.js';
import SystemAlert from '@/models/SystemAlert.js';
import Tag from '@/models/Tag.js';
import Taggable from '@/models/Taggable.js';
import TermScheduleTemplatePeriod from '@/models/TermScheduleTemplatePeriod.js';
import TermScheduleTemplatePeriodCourseTemplate from '@/models/TermScheduleTemplatePeriodCourseTemplate.js';
import TimePeriod from '@/models/TimePeriod.js';
import TimePeriodEnrollment from '@/models/TimePeriodEnrollment.js';
import TimePeriodLocation from '@/models/TimePeriodLocation.js';
import TimePeriodTemplate from '@/models/TimePeriodTemplate.js';
import TimePeriodTemplateLocation from '@/models/TimePeriodTemplateLocation.js';
import TranscriptExcerpt from '@/models/TranscriptExcerpt.js';
import TermSchedule from '@/models/term-schedule/TermSchedule.js';
import TermScheduleCourseModel from '@/models/term-schedule/TermScheduleCourseModel.js';
import TermScheduleGroup from '@/models/term-schedule/TermScheduleGroup.js';
import TermSchedulePeriod from '@/models/term-schedule/TermSchedulePeriod.js';
import TermSchedulePeriodCourse from '@/models/term-schedule/TermSchedulePeriodCourse.js';
import TermTemplate from '@/models/term-template/TermTemplate.js';
import TermTemplatePeriod from '@/models/term-template/TermTemplatePeriod.js';
import TermTemplatePeriodCourseTemplate from '@/models/term-template/TermTemplatePeriodCourseTemplate.js';
import TermBuilder from '@/models/terms/TermBuilder.js';
import Timeline from '@/models/timelines/Timeline.js';
import TimelineCategory from '@/models/timelines/TimelineCategory.js';
import TimelineCheckpoint from '@/models/timelines/TimelineCheckpoint.js';
import TimelineCheckpointType from '@/models/timelines/TimelineCheckpointType.js';
import User from '@/models/User.js';
import UserGroup from '@/models/UserGroup.js';
import UserSetting from '@/models/UserSetting.js';
import Video from '@/models/Video.js';
import VideoActivity from '@/models/VideoActivity.js';
import VideoActivityTemplate from '@/models/VideoActivityTemplate.js';
import VideoGroup from '@/models/VideoGroup.js';
import ViewInformationActivity from '@/models/ViewInformationActivity.js';
import ViewInformationActivityTemplate from '@/models/ViewInformationActivityTemplate.js';
import Widget from '@/models/Widget.js';
import WidgetLayoutTemplate from '@/models/WidgetLayoutTemplate.js';
import WidgetTemplate from '@/models/WidgetTemplate.js';
import axios from '@/plugins/axios.js';
import LoadedRelationships from '@/plugins/vuex-orm/LoadedRelationships.js';
import MorphManyPatch from '@/plugins/vuex-orm/MorphManyPatch.js';
import EbookActivity from '../models/EbookActivity';

VuexORM.use(VuexORMAxios, {
    axios,
    baseURL: '/',
    dataKey: 'data',
});

VuexORM.use(VuexORMSearch, {});

VuexORM.use(VuexORMisDirtyPlugin);
VuexORM.use(MorphManyPatch);

VuexORM.use(LoadedRelationships);

const database = new VuexORM.Database();

// Register models
database.register(CourseTemplate);
database.register(TermScheduleTemplatePeriodCourseTemplate);
database.register(TermScheduleTemplatePeriod);
database.register(EvaluationTemplate);
database.register(FeatureFlag);
database.register(CourseCodeEvaluationTemplate);
database.register(AutomatedSurveyTemplate);
database.register(GroupCategory);
database.register(AutomatedSurveyTarget);
database.register(AutomatedSurveyAssignment);
database.register(Group);
database.register(Course);
database.register(CourseSettingsTemplate);
database.register(CourseEnrollment);
database.register(EnrollmentGroup);
database.register(EnrollmentGroupColor);
database.register(CourseEnrollmentEnrollmentGroup);
database.register(CourseGroup);
database.register(CourseTemplateGroup);
database.register(User);
database.register(CourseSettings);
database.register(Media);
database.register(ModelRole);
database.register(ModelPermission);
database.register(PageFolder);
database.register(Quiz);
database.register(PageGroup);
database.register(PageViewGroup);
database.register(Page);
database.register(Role);
database.register(Reply);
database.register(UserGroup);
database.register(UserSetting);
database.register(Tag);
database.register(Taggable);
database.register(MeetingUser);
database.register(Message);
database.register(MessageMenu);
database.register(MessageAlert);
database.register(CourseAnnouncement);
database.register(DiscussionThread);
database.register(MeetingParticipant);
database.register(MeetingParticipantLog);
database.register(MeetingParticipantComment);
database.register(Meeting);
database.register(MeetingLink);
database.register(MeetingRecording);
database.register(TranscriptExcerpt);
database.register(ChatExcerpt);
database.register(ActivityUpdate);
database.register(Notification);
database.register(DiscussionReply);
database.register(SectionSettingsTemplate);
database.register(SectionTemplate);
database.register(Section);
database.register(SectionSettings);
database.register(TimePeriod);
database.register(TimePeriodTemplate);
database.register(TimePeriodTemplateLocation);
database.register(TimePeriodLocation);
database.register(EnrollmentGroupTimePeriod);
database.register(TimePeriodEnrollment);
database.register(SatisfierTemplate);
database.register(Satisfier);
database.register(Status);
database.register(ActivityTemplate);
database.register(Activity);
database.register(ActivityStatus);
database.register(ActivityType);
database.register(VideoGroup);
database.register(VideoActivity);
database.register(VideoActivityTemplate);
database.register(IdentityVerification);
database.register(IdentityVerificationAttemptQuestions);
database.register(Video);
database.register(SlideDeck);
database.register(SlideDeckGroup);
database.register(Icon);
database.register(Timeline);
database.register(TimelineCategory);
database.register(TimelineCheckpoint);
database.register(TimelineCheckpointType);
database.register(Status);
database.register(Permission);
database.register(RolePermission);
database.register(GradebookPreview);
database.register(Note);
database.register(RubricBank);
database.register(RubricBankGroup);
database.register(Location);
database.register(LocationType);
database.register(LocationGroup);
database.register(AttendanceScenario);
database.register(Contact);
database.register(LocationContact);
database.register(Prerequisite);
database.register(Attendance);
database.register(AttendanceComment);
database.register(LogicalAttendanceWeek);
database.register(QuizAttemptManager);
database.register(CourseLogEntry);
database.register(Gradebook);
database.register(CourseCodes);
database.register(CourseCodeable);
database.register(AttemptAuthorization);
database.register(ActivitySubmission);
database.register(GradebookGrade);
database.register(GradingScheme);
database.register(GradingSchemeCriteria);
database.register(CourseGrade);
database.register(ActivitySettings);
database.register(ActivitySettingsTemplate);
database.register(DiscussionThreadActivity);
database.register(Rubric);
database.register(RubricCriteria);
database.register(RubricCriteriaRating);
database.register(Remediation);
database.register(RemediationProcess);
database.register(CourseGrade);
database.register(QuizAttempt);
database.register(QuizActivity);
database.register(ViewInformationActivity);
database.register(FileSubmissionActivity);
database.register(AcknowledgeInformationActivity);
database.register(PodcastActivity);
database.register(VideoActivity);
database.register(SlideDeckActivity);
database.register(SlideDeckActivityTemplate);
database.register(FlashcardActivity);
database.register(ElearningPackageActivity);
database.register(FlashcardActivityTemplate);
database.register(FlashcardBuilderState);
database.register(FlashcardSessionState);
database.register(ViewInformationActivityTemplate);
database.register(FileSubmissionActivityTemplate);
database.register(AcknowledgeInformationActivityTemplate);
database.register(PodcastActivityTemplate);
database.register(SlideDeckActivityTemplate);
database.register(AutomatedSurvey);
database.register(Objective);
database.register(ObjectiveCriteria);
database.register(SystemAlert);
database.register(ConfirmNavigationWindow);
database.register(TermSchedule);
database.register(TermSchedulePeriod);
database.register(TermSchedulePeriodCourse);
database.register(TermScheduleGroup);
database.register(TermTemplate);
database.register(TermTemplatePeriod);
database.register(TermTemplatePeriodCourseTemplate);
database.register(ProctorDashboardControlPanel);
database.register(Widget);
database.register(WidgetTemplate);
database.register(WidgetLayoutTemplate);
database.register(ReadReceipt);
database.register(Dashboard);
database.register(CourseTemplateMenuItem);
database.register(LtiContext);
database.register(LtiResourceContent);
database.register(LtiResourceLink);
database.register(LtiResourceLinkActivity);
database.register(LtiResourceLinkActivityTemplate);
database.register(LtiToolActivity);
database.register(LtiToolActivityTemplate);
database.register(LtiTool);
database.register(LtiToolDeployment);
database.register(BellNotification);
database.register(InstitutionSetting);
database.register(TermBuilder);
database.register(TermScheduleCourseModel);
database.register(Intervention);
database.register(InterventionLog);
database.register(InterventionMethod);
database.register(Survey);
database.register(SurveyActivity);
database.register(AnomalyDetection);
database.register(AnomalyDetectionResult);
database.register(Integration);
database.register(EbookActivity);
export default VuexORM.install(database);
